import styled from 'styled-components';

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  color: #131313;
  white-space: nowrap;
`;

export const LabelText = styled.span`
  font-weight: 500;
`;

export const RequiredMark = styled.span`
  color: #d83143;
  font-weight: 400;
`;

export const InputWrapper = styled.div<{ $hasError?: boolean }>`
  display: flex;
  align-items: center;
  height: 40px;
  border: 1px solid
    ${({ $hasError, theme }) => ($hasError ? theme.colors.red.quinary : '#bbbcbf')};
  border-radius: 5px;
  background: #ffffff;
  overflow: hidden;
  padding: 0 12px;
  gap: 12px;
  box-sizing: border-box;

  &:focus-within {
    border-color: ${({ $hasError, theme }) =>
      $hasError ? theme.colors.red.quinary : '#01ab7d'};
  }
`;

export const ErrorMessage = styled.span`
  font-family: 'Noto Sans', sans-serif;
  font-size: 12px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.red.quinary};
`;

export const Input = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  padding: 0;
  font-size: 14px;
  line-height: 1.4;
  color: #131313;
  background: transparent;

  &:disabled {
    background: #f5f5f5;
    color: #9b9b9b;
    cursor: not-allowed;
  }
`;

export const ToggleButtonWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ToggleButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
